import {
  Avatar,
  Box,
  Divider,
  IconButton,
  Menu,
  MenuItem,
  Paper,
  styled,
  Typography,
} from "@mui/material";
import { COLORS } from "colors/color";
import React from "react";
import { useState } from "react";
import SettingsIcon from "../../assets/img/settingsIcon.png";
import LogoutIcon from "../../assets/img/logoutIcon.png";
import { useNavigate } from "react-router-dom";
import LanguageSelector from "../../layouts/LanguageSelector";
import { useTranslation } from "react-i18next"; // Import useTranslation

const StyledPaper = styled(Paper)(({ theme }) => ({
  padding: theme.spacing(2),
  [theme.breakpoints.up('sm')]: {
    padding: theme.spacing(3),
  },
  marginBottom: theme.spacing(2),
  [theme.breakpoints.up('sm')]: {
    marginBottom: theme.spacing(3),
  },
  marginTop: theme.spacing(-1),
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  backgroundColor: "#fff",
  borderRadius: "16px",
  boxShadow: "0 4px 50px 0 #0000000D",
}));

function WelcomeSection({ formData }) {
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const navigate = useNavigate();
  const { t } = useTranslation(); // Use the useTranslation hook

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleLogout = () => {
    localStorage.removeItem("accessToken");
    navigate("/login");
  };

  return (
    <StyledPaper>
      <Typography
        sx={{
          color: COLORS.title_color,
          fontWeight: "bold",
          fontSize: { xs: '15px', sm: '17px' },
          opacity: "80%",
          paddingLeft: { xs: 1, sm: 2 },
        }}
      >
        {t("welcome_message", { name: formData.first_name || "" })}
      </Typography>
      <IconButton
        aria-label="more"
        id="long-button"
        aria-controls={open ? "long-menu" : undefined}
        aria-expanded={open ? "true" : undefined}
        aria-haspopup="true"
        onClick={handleClick}
        sx={{
          '& .MuiAvatar-root': {
            width: { xs: 32, sm: 40 },
            height: { xs: 32, sm: 40 },
          }
        }}
      >
        <Avatar
          sx={{
            bgcolor: "#e0e0e0",
            color: "#020060",
            fontWeight: "bold",
            boxShadow: "0 0 20px 0 #0000001A",
          }}
          src={formData.image}
        >
          {formData.first_name.charAt(0).toUpperCase()}
        </Avatar>
      </IconButton>
      <Menu
        id="long-menu"
        MenuListProps={{
          "aria-labelledby": "long-button",
        }}
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        slotProps={{
          paper: {
            elevation: 0,
            sx: {
              boxShadow: "0 0 30px 5px #0000000D",
              mt: 0.5,
              borderRadius: 4,
              "& .MuiAvatar-root": {
                width: 32,
                height: 32,
                ml: -0.5,
                mr: 1.5,
              },
              "&::before": {
                content: '""',
                display: "block",
                position: "absolute",
                top: 0,
                right: 14,
                width: 10,
                height: 10,
                bgcolor: "background.paper",
                transform: "translateY(-50%) rotate(45deg)",
                zIndex: 0,
              },
            },
          },
        }}
        transformOrigin={{ horizontal: "right", vertical: "top" }}
        anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
      >
        <MenuItem sx={{ gap: 2 }}>
          <img src={SettingsIcon} alt="Settings" />
          <Typography
            sx={{
              fontFamily: "Poppins",
            }}
          >
            {t("settings")} {/* Use translation */}
          </Typography>
        </MenuItem>
        <Divider sx={{ mx: 1 }} />
        <MenuItem sx={{ gap: 2 }} onClick={handleLogout}>
          <img src={LogoutIcon} alt="Logout" />
          <Typography
            sx={{
              fontFamily: "Poppins",
            }}
          >
            {t("logout")} {/* Use translation */}
          </Typography>
        </MenuItem>
        <LanguageSelector />
      </Menu>
    </StyledPaper>
  );
}

export default WelcomeSection;